<template lang="pug">
  .catalog
    .catalog__head
      Breadcrumbs(:breadcrumbsList="breadcrumbsList")
      .catalog__title
        h1.page-title {{ $t('pages.catalog.title') }}
      CatalogFilters(:products="allProducts" @filterProducts="applyFilters")
    ProductsList(:products="filteredProducts")
</template>

<script>
import _ from 'lodash'
import api from '@/api/index'
import Breadcrumbs from '@/components/partials/Breadcrumbs'
import CatalogFilters from '@/components/filters/CatalogFilters'
import ProductsList from '@/components/products/ProductsList'

export default {
  components: { ProductsList, Breadcrumbs, CatalogFilters },

  data() {
    return {
      allProducts: [],
      filteredProducts: [],

      breadcrumbsList: [
        {
          link: this.localePath('index'),
          name: this.$t('breadcrumbs.home')
        },
        {
          link: this.localePath('catalog'),
          name: this.$t('breadcrumbs.allShoes')
        }
      ]
    }
  },

  head() {
		let breadcrumbsMarkup = {
			"@context": "https://schema.org",
			"@type": "BreadcrumbList",
				"itemListElement": [{
					"@type": "ListItem",
					"position": 1,
					"name": this.$t('breadcrumbs.home'),
					"item": 'https://sitelle.ua' + this.localePath('index')
				},{
					"@type": "ListItem",
					"position": 2,
					"name": this.$t('breadcrumbs.allShoes'),
					"item": 'https://sitelle.ua' + this.localePath('catalog')
				}]
		}

    return {
      title: this.$t('meta.catalog.title'),
      titleTemplate: null,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('meta.catalog.description')
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.$t('meta.catalog.title')
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.$t('meta.catalog.description')
        }
			],
			script: [
				{
					type: 'application/ld+json',
					innerHTML: JSON.stringify(breadcrumbsMarkup)
				}
			]
    }
  },

  async asyncData({ store }) {
    const data = await api.getProducts(
      store.state.geoData.locale,
      store.state.geoData.currency
    )

    return {
      allProducts: data,
      filteredProducts: data
    }
  },

  methods: {
    applyFilters(products) {
      this.filteredProducts = products
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/scss/helpers/vars';
@import '~assets/scss/helpers/mixins';

.catalog {
  position: relative;
  margin-right: 100px;
  padding-top: 20px;

  @include tablet {
    margin-right: 0;
  }

  .breadcrumbs {
    margin-bottom: 10px;
  }

  &__title {
    margin-bottom: 5px;
  }
}

.catalog-loading {
  position: absolute;
  z-index: 5;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba($whiteColor, 0.9);
}
</style>
